
    export default {
        name: 'SectionTestimonials',

        props: {
            animate: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                group1: [
                    {
                        ref: 'groupOne1',
                        name: 'Lisa',
                        content: '“Very easy experience. I’ve gotten two calls within a week. So happy I made the investment“',
                    },
                    {
                        ref: 'groupOne2',
                        name: 'Kam',
                        content: '“At first I was skeptical about the service and how good a job they could do virtually and without closer interactions. However, it ended up being a good experience. After about 4 or 5 days, the resume writer sent me a completely revamped version of my resume, more concise and better structured. We also had additional back and forth messaging afterwards where the writer made additional changes. My writer was very responsive to my suggestions/requests.“',
                    },
                    {
                        ref: 'groupOne3',
                        name: 'Chris',
                        content: '“Fast turnaround-time, answered my questions, and did everything I asked, even the small details. Highly recommended!“',
                    },
                ],
                group2: [
                    {
                        ref: 'groupTwo1',
                        name: 'Marcella',
                        content: '“I\'ve attempted many times to apply for jobs with my written Resume. I would receive no response or a Thank you, but no thank you response.I hired TopResume to revamp my Resume. My very first attempt of new employment using my new resume was a success! I received a call back and interviewed within days.I was told that the job would require a "steep learning curve" however, they were confident of my ability because of my Resume!“',
                    },
                    {
                        ref: 'groupTwo2',
                        name: 'Hilary',
                        content: '“I was hesitant to pay for these services, but my resume needed some serious help. It wasn\'t a week after I received my updated resume, and I was offered a position. The staff was extremely helpful and responsive-- they were thorough in asking what I wanted and the goals I was hoping to achieve. 10/10-- would recommend to anyone.”',
                    },
                    {
                        ref: 'groupTwo3',
                        name: 'Mark',
                        content: '“Accuracy, swiftness and able to take direction so perfectly! THANKS Top Resume 😘“',
                    },
                ],
                group3: [
                    {
                        ref: 'groupThree1',
                        name: 'Gary',
                        content: '“Excellent service. My writer was able to take a jumbled mess that eventually became 6 un-edited pages of job duties and responsibilities and turned it into a two-page concise document that represents me in a professional manner.”',
                    },
                    {
                        ref: 'groupThree2',
                        name: 'Leslie',
                        content: '“I got the draft back and opened it up and said, ‘Wow!’ It had a pow. Within 30 days, I had two solid offers on the table and one pending.”',
                    },
                    {
                        ref: 'groupThree3',
                        name: 'Julie',
                        content: '“TopResume\'s price was more than reasonable, the turnaround time was rapid, the service was exemplary, and the product was top-notch. I don\'t have any concerns about recommending TopResume to anyone, regardless of where you\'re at in your career.”',
                    },
                ],
            };
        },

        watch: {
            animate(isAnimate) {
                if (isAnimate) {
                    if (this.$mq === 'sm') {
                        this.mobileAnimation();
                    } else if (['md', 'lg'].includes(this.$mq)) {
                        this.tabletAnimation();
                    } else if (['xl', 'inf'].includes(this.$mq)) {
                        this.desktopAnimation();
                    }
                }
            },
        },

        methods: {
            ctaClick($e) {
                this.$emit('ctaClick', $e);
            },
            mobileAnimation() {
                const mobileOrders = [
                    'groupOne1',
                    'groupOne2',
                    'groupOne3',
                    'groupTwo1',
                    'groupTwo2',
                    'groupTwo3',
                    'groupThree1',
                    'groupThree2',
                    'groupThree3',
                ];

                this.animationByOrders(mobileOrders);
            },

            desktopAnimation() {
                const desktopOrders = [
                    'groupOne1',
                    'groupTwo1',
                    'groupThree1',
                    'groupOne2',
                    'groupTwo2',
                    'groupThree2',
                    'groupOne3',
                    'groupTwo3',
                    'groupThree3',
                ];

                this.animationByOrders(desktopOrders);
            },

            tabletAnimation() {
                // Re-positions
                const group1 = [...this.group1, { ...this.group3[0] }, { ...this.group3[2] }];
                const group2 = [...this.group2, { ...this.group3[1] }];
                this.group3 = [];
                this.group1 = group1;
                this.group2 = group2;

                const tabletOrders = [
                    'groupOne1',
                    'groupTwo1',
                    'groupOne2',
                    'groupTwo2',
                    'groupOne3',
                    'groupTwo3',
                    'groupThree1',
                    'groupThree2',
                    'groupThree3',
                ];

                this.animationByOrders(tabletOrders);
            },

            async animationByOrders(orders) {
                const vm = this;
                for (const i in orders) {
                    if (this.isOdd(i)) {
                        await this.$velocity(this.$refs[orders[i]], {
                            opacity: 1,
                            translateY: '-40px',
                        }, {
                            easing: 'easeInOutQuart',
                            duration: 300,
                            begin() {
                                const hasNext = orders[parseInt(i) + 1];
                                if (hasNext) {
                                    const nextElem = vm.$refs[orders[parseInt(i) + 1]];
                                    vm.$velocity(nextElem, {
                                        opacity: 1,
                                        translateY: '-40px',
                                    }, {
                                        easing: 'easeInOutQuart',
                                        duration: 700,
                                        delay: 200,
                                    });
                                }
                            },
                        });
                    }
                }
            },

            isOdd(n) {
                const num = parseInt(n) + 1;
                return Math.abs(num % 2) === 1 || num === 0;
            },
        },
    };
